import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedLayout } from "./components/Layout";
import LoginPage from "./pages/Login";
import DashboardPage from "./pages/Dashboard";
import OrgsPage from "./pages/Orgs";
import ZonesPage from "./pages/Zones";
import WarsPage from "./pages/Wars";
import SettingsPage from "./pages/Settings";
import SeasonsPage from "./pages/Seasons";
import RecipesPage from "./pages/Recipes";
import PublicRankingPage from "./pages/PublicRanking";
import AuditoriaPage from "./pages/Auditoria";
import BackupsPage from "./pages/Backups";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/ranking" element={<PublicRankingPage />} />
          <Route element={<ProtectedLayout />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/orgs" element={<OrgsPage />} />
            <Route path="/zones" element={<ZonesPage />} />
            <Route path="/wars" element={<WarsPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/temporadas" element={<SeasonsPage />} />
            <Route path="/receitas" element={<RecipesPage />} />
            <Route path="/auditoria" element={<AuditoriaPage />} />
            <Route path="/copias" element={<BackupsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
